import React, { useState, useEffect } from 'react'
import { Link, useLocation, Outlet } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import './AdminLayout.css'

const AdminLayout: React.FC = () => {
  const { user, logout } = useAuth()
  const location = useLocation()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const navigation = [
    { name: 'Dashboard', href: '/', icon: '📊' },
    { name: 'Posts', href: '/posts', icon: '📝' },
    { name: 'Categories', href: '/categories', icon: '📁' },
  ]

  if (user?.role === 'admin') {
    navigation.push({ name: 'Users', href: '/users', icon: '👥' })
  }

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false)
      }
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    closeMobileMenu()
  }, [location.pathname])

  return (
    <div className="admin-layout">
      <button 
        className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={toggleMobileMenu}
      >
        {isMobileMenuOpen ? '✕' : '☰'}
      </button>
      
      <div 
        className={`mobile-overlay ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={closeMobileMenu}
      />
      
      <nav className={`sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2>Báo Chính Phủ</h2>
          <span className="admin-badge">Admin</span>
        </div>
        
        <ul className="nav-menu">
          {navigation.map((item) => (
            <li key={item.name}>
              <Link
                to={item.href}
                className={location.pathname === item.href ? 'active' : ''}
              >
                <span className="nav-icon">{item.icon}</span>
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
        
        <div className="sidebar-footer">
          <div className="user-info">
            <strong>{user?.username}</strong>
            <small>{user?.role}</small>
          </div>
          <button onClick={logout} className="logout-btn">
            Đăng xuất
          </button>
        </div>
      </nav>
      
      <main className="main-content">
        <header className="content-header">
          <h1>Quản trị nội dung</h1>
        </header>
        <div className="content-body">
          <Outlet />
        </div>
      </main>
    </div>
  )
}

export default AdminLayout